import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { recargarPlanes } from "@/lib/ocio";
import { eur } from "@/lib/gastos";

const btn = "w-full min-h-[52px] rounded-xl font-semibold text-base";

// Confirmación al borrar un plan; si tiene entrada, se elige conservarla o eliminarla.
export const BorrarPlan = ({ plan, onClose }) => {
  const { fetchAll, gastos = [] } = useData();
  const gasto = plan.documento_id && gastos.find((g) => g.documento_id === plan.documento_id);
  const [ocupado, setOcupado] = useState(false);
  const borrar = async (conDoc) => {
    setOcupado(true);
    try {
      await api.delete(`/ocio/planes/${plan.id}`, { params: { borrar_documento: conDoc } });
      await Promise.all([recargarPlanes(), fetchAll()]);
      toast.success(gasto ? "Plan borrado. El justificante del gasto se conserva." : conDoc ? "Plan y entrada eliminados" : plan.documento_id ? "Plan borrado. La entrada sigue en Entradas y reservas." : "Plan borrado");
      onClose();
    } catch { toast.error("No se pudo borrar el plan."); setOcupado(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-testid="ocio-borrar-dialogo">
      <div className="absolute inset-0 bg-[#1C2421]/40" onClick={onClose} />
      <div className="relative bg-[#FAF8F4] w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-6 space-y-3">
        <h2 className="font-heading text-xl font-bold text-[#1C2421]">¿Borrar el plan «{plan.nombre}»?</h2>
        <p className="text-base text-[#4A5550]">Se borrarán también sus avisos.</p>
        {gasto ? (
          <>
            <p data-testid="ocio-borrar-justificante" className="text-base font-semibold text-[#1C2421] bg-[#E8F0EC] rounded-xl p-3">Este documento es el justificante del gasto de {eur(gasto.importe)} y se conservará aunque elimines el plan.</p>
            <button data-testid="ocio-borrar-confirmar" disabled={ocupado} onClick={() => borrar(false)} className={`${btn} bg-[#B91C1C] text-white`}>Sí, borrar el plan</button>
          </>
        ) : plan.documento_id ? (
          <>
            <p className="text-base font-semibold text-[#1C2421]">¿Qué quieres hacer con la entrada o reserva?</p>
            <button data-testid="ocio-borrar-conservar-doc" disabled={ocupado} onClick={() => borrar(false)} className={`${btn} bg-[#3A6B56] text-white`}>Conservar el documento</button>
            <button data-testid="ocio-borrar-eliminar-doc" disabled={ocupado} onClick={() => borrar(true)} className={`${btn} border border-[#FECACA] text-[#B91C1C] bg-white`}>Eliminar también el documento</button>
          </>
        ) : (
          <button data-testid="ocio-borrar-confirmar" disabled={ocupado} onClick={() => borrar(false)} className={`${btn} bg-[#B91C1C] text-white`}>Sí, borrar el plan</button>
        )}
        <button data-testid="ocio-borrar-cancelar" onClick={onClose} className={`${btn} text-[#4A5550]`}>Cancelar</button>
      </div>
    </div>
  );
};
